import axios from "axios";

export default axios.create({
    baseURL:'https://bloomhope-20881.firebaseio.com/'
})
